import { put, takeLatest, call } from "redux-saga/effects";
import { citiesLoaded } from "../../actions/cities";
import searchEngineers from "sc/backend/oncall/partners/cities/list-regions";
import listCities from "../../../../../backend/oncall/partners/cities/list";
import {
  ENGINEER_SEARCH_PAGE_LOAD,
  engineerSearchResultsLoaded,
} from "../../actions/engineers";
import { showErrorPage } from "../../../../../actions/ui/location";

const engineersSearchPageLoadSaga = function*(action) {
  try {
    const searchEngineersResult = yield call(
      searchEngineers,
      action.payload.cityId,
    );
    yield put(engineerSearchResultsLoaded(searchEngineersResult.regions));
    const result = yield call(listCities);
    yield put(citiesLoaded(result.cities));
  } catch (ignore) {
    yield put(showErrorPage());
  }
};
export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(ENGINEER_SEARCH_PAGE_LOAD, engineersSearchPageLoadSaga);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/engineers/search-page-load.js